module.exports = __webpack_public_path__ + "img/czt-ding.a2b91957.png";